export default [
  {
    path: '/notice-department/reconfirmation-statistic',
    name: 'pageReconfirmationStatistic',
    meta: { title: 'page.pageReconfirmationStatistic', roles: ['SIDEBAR_STATS_REPEAT_CONFIRM'] },
    component: () => import('@/pages/notice-department/reconfirmation-statistic'),
  },
]
